module.exports = __webpack_public_path__ + "static/media/4_6.282c98e8.jpg";